const config = {
    // Defaults...
    // ===========

    environment: {},
    siteId: null,
    endpoints: {},
    serviceKeys: {},
    storageKeys: {
        authToken: 'lag.api.auth.authtoken'
    },

    maxRequestSizeMB: 15,

    // Convenience accessor methods...
    // ===============================

    /**
     * Indicates if we are in debug mode, either development environment or the URL's query string contains 'DEBUG' param (its value does not matter).
     */
    get isDebug() {
        return /[&?]DEBUG\b/.test(location.search)
            || this.environment.isDevelopment;
    }
};

// Apply server injected config values.
Object.assign(config, window.lag.config); // window.lag.config should be injected by server generated HTML.

Object.assign(config.environment, {
    isProduction: config.environment.name && (/production/i).test(config.environment.name),
    isStaging: config.environment.name && (/staging/i).test(config.environment.name),
    isDevelopment: config.environment.name && (/development/i).test(config.environment.name)
});

const otherEnvironment =
    !config.environment.isProduction
    && !config.environment.isStaging
    && !config.environment.isDevelopment;

// If another environment (eg "TDD", "UAT", etc) then default to staging.
if (otherEnvironment) {
    config.environment.isStaging = true;
}

export { config };